"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.i18next = exports.setLanguageCookie = exports.autoInit = exports.clear = exports.changeLanguage = exports.addResourceBundle = exports.hasInitFromOtherLib = exports.initI18Next = exports.getCurrentLanguage = exports.isChinese = exports.languageMapping = exports.languageMap = exports.supportLngDesc = exports.supportLngTypes = void 0;
var i18next_1 = require("i18next"), i18next2 = i18next_1;
var i18next_browser_languagedetector_1 = require("i18next-browser-languagedetector"), i18nextBrowserLngDetector = i18next_browser_languagedetector_1;
var js_cookie_1 = require("js-cookie"), cookies2 = js_cookie_1;
var constants_1 = require("./src/constants");
Object.defineProperty(exports, "Language", { enumerable: true, get: function () { return constants_1.Language; } });
var utilities_1 = require("./src/utilities");
var languageDetector_1 = require("./src/languageDetector");
var cookies = js_cookie_1.default || cookies2;
var browserDetector = i18next_browser_languagedetector_1.default || i18nextBrowserLngDetector;
var i18next = i18next_1.default || i18next2;
exports.i18next = i18next;
var DefaultNamespace = 'translation';
exports.supportLngTypes = [
    constants_1.Language[constants_1.Language.zh_CN],
    constants_1.Language[constants_1.Language.zh_TW],
    constants_1.Language[constants_1.Language.zh_HK],
    constants_1.Language[constants_1.Language.en_US],
    constants_1.Language[constants_1.Language.ja_JP],
    constants_1.Language[constants_1.Language.vi_VN],
    constants_1.Language[constants_1.Language.th_TH],
    constants_1.Language[constants_1.Language.ne_NP],
    constants_1.Language[constants_1.Language.id_ID],
    constants_1.Language[constants_1.Language.ms_MY],
    constants_1.Language[constants_1.Language.ko_KR],
    constants_1.Language[constants_1.Language.es_LA],
    constants_1.Language[constants_1.Language.fr_FR],
    constants_1.Language[constants_1.Language.ru_RU],
    constants_1.Language[constants_1.Language.pt_BR],
    constants_1.Language[constants_1.Language.tr_TR],
];
var cacheAddResource = [];
var i18nextTranslationFunc = i18next.t.bind(i18next);
exports.supportLngDesc = [
    {
        text: '简体中文',
        type: constants_1.Language[constants_1.Language.zh_CN],
    },
    {
        text: '繁體中文（台灣）',
        type: constants_1.Language[constants_1.Language.zh_TW],
    },
    {
        text: '繁體中文（香港）',
        type: constants_1.Language[constants_1.Language.zh_HK],
    },
    {
        text: 'English',
        type: constants_1.Language[constants_1.Language.en_US],
    },
    {
        text: '日本語',
        type: constants_1.Language[constants_1.Language.ja_JP],
    },
    {
        text: 'ไทย',
        type: constants_1.Language[constants_1.Language.th_TH],
    },
    {
        text: 'नेपाली',
        type: constants_1.Language[constants_1.Language.ne_NP],
    },
    {
        text: 'Bahasa indonesia',
        type: constants_1.Language[constants_1.Language.id_ID],
    },
    {
        text: 'Melayu',
        type: constants_1.Language[constants_1.Language.ms_MY],
    },
    {
        text: '한국어',
        type: constants_1.Language[constants_1.Language.ko_KR],
    },
    {
        text: 'Español',
        type: constants_1.Language[constants_1.Language.es_LA],
    },
    {
        text: 'Français',
        type: constants_1.Language[constants_1.Language.fr_FR],
    },
    {
        text: 'Русский',
        type: constants_1.Language[constants_1.Language.ru_RU],
    },
    {
        text: 'Português',
        type: constants_1.Language[constants_1.Language.pt_BR],
    },
    {
        text: 'Türkçe',
        type: constants_1.Language[constants_1.Language.tr_TR],
    },
];
exports.languageMap = {
    'zh-CN': constants_1.Language[constants_1.Language.zh_CN],
    'zh_CN': constants_1.Language[constants_1.Language.zh_CN],
    'zh': constants_1.Language[constants_1.Language.zh_CN],
    'zh_cn': constants_1.Language[constants_1.Language.zh_CN],
    'en_US': constants_1.Language[constants_1.Language.en_US],
    'en-US': constants_1.Language[constants_1.Language.en_US],
    'en': constants_1.Language[constants_1.Language.en_US],
    'zh_TW': constants_1.Language[constants_1.Language.zh_TW],
    'zh-TW': constants_1.Language[constants_1.Language.zh_TW],
    'zh-HK': constants_1.Language[constants_1.Language.zh_HK],
    'zh_HK': constants_1.Language[constants_1.Language.zh_HK],
    'zh-Hans': constants_1.Language[constants_1.Language.zh_CN],
    'zh_Hans': constants_1.Language[constants_1.Language.zh_CN],
    'zh-Hant': constants_1.Language[constants_1.Language.zh_TW],
    'zh_Hant': constants_1.Language[constants_1.Language.zh_TW],
    'zh-Hans-CN': constants_1.Language[constants_1.Language.zh_CN],
    'zh-Hant-CN': constants_1.Language[constants_1.Language.zh_TW],
    'zh-Hant-HK': constants_1.Language[constants_1.Language.zh_HK],
    'zh-Hant-MO': constants_1.Language[constants_1.Language.zh_TW],
    'zh-Hant-SG': constants_1.Language[constants_1.Language.zh_TW],
    'zh-Hant-TW': constants_1.Language[constants_1.Language.zh_TW],
    'ja': constants_1.Language[constants_1.Language.ja_JP],
    'ja_JP': constants_1.Language[constants_1.Language.ja_JP],
    'ja-JP': constants_1.Language[constants_1.Language.ja_JP],
    'vi': constants_1.Language[constants_1.Language.vi_VN],
    'vi_VN': constants_1.Language[constants_1.Language.vi_VN],
    'th': constants_1.Language[constants_1.Language.th_TH],
    'th_TH': constants_1.Language[constants_1.Language.th_TH],
    'ne': constants_1.Language[constants_1.Language.ne_NP],
    'ne_NP': constants_1.Language[constants_1.Language.ne_NP],
    'id': constants_1.Language[constants_1.Language.id_ID],
    'id_ID': constants_1.Language[constants_1.Language.id_ID],
    'ms': constants_1.Language[constants_1.Language.ms_MY],
    'ms_MY': constants_1.Language[constants_1.Language.ms_MY],
    'ko': constants_1.Language[constants_1.Language.ko_KR],
    'ko_KR': constants_1.Language[constants_1.Language.ko_KR],
    'es': constants_1.Language[constants_1.Language.es_LA],
    'es_LA': constants_1.Language[constants_1.Language.es_LA],
    'fr': constants_1.Language[constants_1.Language.fr_FR],
    'fr_FR': constants_1.Language[constants_1.Language.fr_FR],
    'ru': constants_1.Language[constants_1.Language.ru_RU],
    'ru_RU': constants_1.Language[constants_1.Language.ru_RU],
    'pt': constants_1.Language[constants_1.Language.pt_BR],
    'pt_BR': constants_1.Language[constants_1.Language.pt_BR],
    'tr': constants_1.Language[constants_1.Language.tr_TR],
    'tr_TR': constants_1.Language[constants_1.Language.tr_TR],
};
function languageMapping(rawLanguage) {
    return constants_1.Language[(0, utilities_1.getStandardLanguage)(rawLanguage)];
}
exports.languageMapping = languageMapping;
/**
 * 判断当前场景是否是中文环境
 * @param options:
 * {
 *   simplifiedOnly: boolean, 布尔值，指定是否仅考虑简体中文，默认值是 true
 * }
 */
function isChinese(options) {
    if (options === void 0) { options = { simplifiedOnly: true }; }
    var currentLanguage = getCurrentLanguage();
    var simplifiedOnly = options.simplifiedOnly;
    if (simplifiedOnly) {
        return currentLanguage === constants_1.Language.zh_CN;
    }
    return [constants_1.Language.zh_CN, constants_1.Language.zh_TW, constants_1.Language.zh_HK].indexOf(currentLanguage) >= 0;
}
exports.isChinese = isChinese;
/**
 * 获取当前语言的枚举值
 */
function getCurrentLanguage() {
    return (0, utilities_1.getStandardLanguage)(i18next.language);
}
exports.getCurrentLanguage = getCurrentLanguage;
var isInit = false;
function afterInit() {
    var cacheResource;
    if (cacheAddResource.length > 0) {
        cacheResource = cacheAddResource;
        cacheAddResource = [];
        cacheResource.forEach(function (item) {
            addResourceBundle(item.resource, item.namespace);
        });
    }
}
function initI18Next(language, resource, options) {
    if (isInit) {
        throw new Error('Do not repeat init i18n');
    }
    isInit = true;
    var resourceObj = {};
    if (language) {
        language = languageMapping(language);
    }
    if (resource) {
        Object.keys(exports.languageMap).forEach(function (lang) {
            resourceObj[lang] = {
                translation: resource[exports.languageMap[lang]],
            };
        });
    }
    var fallbackLng = {
        'zh_HK': ['zh_TW', 'zh_CN'],
        'zh-HK': ['zh_TW', 'zh_CN'],
        'default': ['en_US'],
    };
    var initOptions = options || {};
    initOptions.fallbackLng = fallbackLng;
    initOptions.resources = resourceObj;
    if (language) {
        initOptions.lng = language;
        i18next.init(initOptions);
    }
    else {
        initOptions.detection = {
            // order and from where user language should be detected
            order: ['navigator'],
            caches: [],
        };
        i18next.use(browserDetector).init(initOptions);
    }
    afterInit();
}
exports.initI18Next = initI18Next;
function hasInitFromOtherLib() {
    isInit = true;
    afterInit();
}
exports.hasInitFromOtherLib = hasInitFromOtherLib;
function addResourceBundle(resource, namespace) {
    var ns = namespace || DefaultNamespace;
    if (isInit) {
        Object.keys(exports.languageMap).forEach(function (lang) {
            if (resource[exports.languageMap[lang]]) {
                i18next.addResourceBundle(lang, ns, resource[exports.languageMap[lang]]);
            }
        });
    }
    else {
        cacheAddResource.push({
            namespace: ns,
            resource: resource,
        });
    }
}
exports.addResourceBundle = addResourceBundle;
function changeLanguage(lang) {
    i18next.changeLanguage(lang);
}
exports.changeLanguage = changeLanguage;
function clear(namespace) {
    var ns = DefaultNamespace;
    i18next.t = i18nextTranslationFunc;
    if (namespace) {
        ns = namespace;
    }
    Object.keys(exports.languageMap).forEach(function (lang) {
        if (i18next.removeResourceBundle) {
            i18next.removeResourceBundle(lang, ns);
        }
    });
    isInit = false;
}
exports.clear = clear;
function setTranslationFuncToShowKey() {
    i18next.t = function (key) {
        if ((0, utilities_1.hasWindow)()) {
            window.console.log(key, i18nextTranslationFunc(key));
        }
        return key;
    };
}
/**
 * 获取当前浏览器容器配置的语言，没有的话为 null
 */
function getLanguageFromBrowser() {
    var lang = (0, languageDetector_1.default)();
    return lang !== null ? constants_1.Language[lang] : null;
}
/**
 * 初始化函数，在项目入口处使用
 * @param resource - 文案资源
 * @param aLanguage - 指定语言（不传递会基于环境自动判断）
 * @param options - i18next 的配置，具体详情可以去这里参考 [i18next](https://www.i18next.com/)
 */
function autoInit(resource, aLanguage, options) {
    if (needShowMcmsKey()) {
        setTranslationFuncToShowKey();
    }
    var language = aLanguage || getLanguageFromBrowser();
    initI18Next(language || '', resource, options);
}
exports.autoInit = autoInit;
function needShowMcmsKey() {
    var indicator = constants_1.SHOW_MCMS_KEY_INDICATOR.toLowerCase();
    var showByNavigator = (0, utilities_1.hasWindow)() && window.navigator && window.navigator.userAgent &&
        window.navigator.userAgent.toLowerCase().indexOf(indicator) >= 0;
    var showByUrl = (0, utilities_1.hasWindow)() && window.location && window.location.href && window.location.host &&
        window.location.host.indexOf('pre-') === 0 &&
        window.location.href.toLowerCase().indexOf(indicator) >= 0;
    var showByCookie = cookies.get(constants_1.SHOW_MCMS_KEY_INDICATOR) === '1';
    return showByNavigator || showByUrl || showByCookie;
}
function setLanguageCookie(lang, currentDomainOnly) {
    if (currentDomainOnly === void 0) { currentDomainOnly = false; }
    if ((0, utilities_1.hasWindow)()) {
        // cookies 中直接使用了 document
        var hostname = window.location.hostname;
        var list = hostname.split('.');
        var length_1 = list.length;
        var domain = currentDomainOnly ? hostname : '.' + list[length_1 - 2] + '.' + list[length_1 - 1];
        cookies.remove(constants_1.COOKIE_NAME);
        cookies.set(constants_1.COOKIE_NAME, lang, { expires: 365, domain: domain });
    }
}
exports.setLanguageCookie = setLanguageCookie;
//# sourceMappingURL=index.js.map